/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner {
  'name'?: string;
  'location'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

